export const isGenesGtpHeatmapEnabled = process.env.REACT_APP_SHOW_GENES_GTP_HEATMAP === 'true';
